module.exports = __webpack_public_path__ + "static/a-xx-033-art-bf9a4cec451630e3c71a2dba50224aef.jpg";